// removed by extract-text-webpack-plugin
module.exports = {"root":"_2Pp0uonk6Lo-1fiCPhHI0j_0","list":"_1a3P1-8Qm84_CkYBD4t1ZP_0","item":"_33guiY9a37A7R5luD9LUyS_0","link":"_3QCNXaCvDZaNoF7JoFONcF_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9ee23334","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Breadcrumbs.vue
// module id = RzBu
// module chunks = 21